module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/gabriela-brzozowska-79de4f9ab470265f707a78a22f058d82.webp";